import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
		lxh: null,
		insert: false,
		update: false,
		loading: false,
		existsPendingTransactions: false
	},
	getters: {
		
	},
	mutations: {
		set(state, lxh){
			state.lxh = lxh
			if (lxh)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
		},
		setExistsPendingTransactions(state, existsPendingTransactions){
			state.existsPendingTransactions = existsPendingTransactions
		}
	},
	actions: {
		async find(store, isInNewTerminalForm = false){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/PaymentCondition/TEFIntegrationParameters/Find")
			.then(async (response) => {
				let lxh = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", lxh)

				if(!(store.rootState.pd0 && store.rootState.pd0.pd0) && !isInNewTerminalForm){
					let terminal = localStorage.getItem("terminal")
					if (terminal) {
						const pd0codigo = JSON.parse(terminal).pd0codigo
						await store.dispatch("pd0/find", pd0codigo, {root: true})
					}
				}

				if(lxh)
					this._vm.$tefAxios.defaults.baseURL = `${window.location.protocol}//localhost:${lxh.lxhcliport}`
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
			return true
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/PaymentCondition/TEFIntegrationParameters/Insert", store.state.lxh )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/PaymentCondition/TEFIntegrationParameters/Update", store.state.lxh )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete("/PaymentCondition/TEFIntegrationParameters/Delete")
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				store.dispatch("find")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async existsPendingTransactions(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Pesquisando transações pendentes", indeterminate: true }, {root: true})
			await this._vm.$tefAxios.get("/TEF/ExistsPendingTransactions")
			.then(response => {
				store.commit("setExistsPendingTransactions", Utils.ValidateAxiosResponse(response.data))
				return true
			})
			.catch((error) => {
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return true			
		},
		async findNextPendingTransaction(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Pesquisando transações pendentes", indeterminate: true }, {root: true})
			let payload = await this._vm.$tefAxios.get("/TEF/FindNextPendingTransaction")
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload			
		},
		async pendingTransactionCheck(store, { lxi, confirm, lstCv8 }){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Alterando dados da transação", indeterminate: true }, {root: true})
			let payload = await this._vm.$tefAxios.post("/TEF/PendingTransactionCheck", {
				lxi,
				confirm,
				lstCv8
			})
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload			
		}
	}
}